import { IPropsWithChildren, IPropsWithClassName } from 'interfaces';

import styles from './styles';

export interface GrayContainerProps extends IPropsWithClassName, IPropsWithChildren {
}

const GrayContainer = ({
  children,
  className,
}: GrayContainerProps) => (
  <section className={styles.component(className)}>
    {children}
  </section>
);

export default GrayContainer;
